import React, { useEffect, useState } from "react";
import { Modal, Button, Checkbox, Input } from "antd";
import { useSelector } from "react-redux";
import searchIcon from "../../assets/Icons/input-search-icon.svg";
import "./ChartFilter.scss";

const categories = [
  { title: "Team Member", value: "team_member" },
  { title: "Team Leader", value: "team_leader" },
];

const ChartFilterModal = ({
  setPrimaryItems,
  setSecondaryItems,
  secondaryItems = [],
  primaryItems,
  setOpen,
  open,
  selectedTrustMap,
  setSelectedTrustMap,
  selectedCategory,
  setSelectedCategory,
  setRefresh,
}) => {
  const [selectedFilterList, setSelectedFilterList] = useState([]);
  const [search, setSearch] = useState("");

  const [error, setError] = useState("");

  const { filter_list,analyse_filters } = useSelector((state) => state?.filters);

  // Toggle trust while ensuring only one category is selected
  const toggleTrust = (trust) => {
    setSelectedTrustMap(() => {
      const currentList = selectedTrustMap[selectedCategory] || [];
      const updatedList = currentList.includes(trust?.name)
        ? currentList.filter((t) => t !== trust?.name)
        : [...currentList, trust?.name];

      const newMap = {
        team_member: selectedCategory === "team_member" ? updatedList : [],
        team_leader: selectedCategory === "team_leader" ? updatedList : [],
      };

      setSecondaryItems?.(newMap);
      return newMap;
    });
  };

  const clearAll = () => {
    setSelectedTrustMap((prev) => ({
      ...prev,
      [selectedCategory]: [],
    }));
    setSecondaryItems?.([]);
    setError("");
  };

  const applyFilters = () => {
    setError("");
    setOpen(false);
    setRefresh((prev) => !prev);
  };

  const handleSelectAll = () => {
    const updatedList = [...selectedFilterList];
    const newMap = {
      team_member: selectedCategory === "team_member" ? updatedList : [],
      team_leader: selectedCategory === "team_leader" ? updatedList : [],
    };
    setSelectedTrustMap(newMap);
    setSecondaryItems?.(updatedList);
    setError("");
  };

  useEffect(() => {
    if (analyse_filters?.length) {
      const matched = analyse_filters?.find(
        (item) => item?.name === selectedCategory
      );
      setSelectedFilterList(matched?.filters || []);
    } else {
      setSelectedFilterList([]);
    }

    setSecondaryItems?.(selectedTrustMap[selectedCategory] || []);
    setSearch("");
    setError("");
  }, [analyse_filters, selectedCategory]);

  const activeCategory =
    categories.find((cat) => cat.value === selectedCategory)?.title ||
    "Team Member";
  const selectedCount = selectedTrustMap?.[selectedCategory]?.length || 0;

  /* the search narrows the list in place; it used to be an input that did
     nothing at all */
  const visibleList = search
    ? selectedFilterList.filter((trust) =>
        String(trust?.name || "")
          .toLowerCase()
          .includes(search.trim().toLowerCase()),
      )
    : selectedFilterList;

  return (
    <Modal
      open={open}
      title="Drill Down"
      className="chart-filter-modal"
      onCancel={() => setOpen(false)}
      footer={
        <>
          <span className="filter-footer-count">
            {selectedCount > 0
              ? `${selectedCount} selected`
              : "Nothing selected"}
          </span>
          <div className="filter-footer-actions">
            <Button
              className="filter-clear"
              onClick={clearAll}
              disabled={selectedCount === 0}
            >
              Clear all
            </Button>
            <Button className="filter-apply" onClick={applyFilters}>
              Apply
            </Button>
          </div>
        </>
      }
    >
      <div className="filter-search">
        <Input
          prefix={<img src={searchIcon} alt="icon" />}
          placeholder={`Search ${activeCategory.toLowerCase()}`}
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          allowClear
        />
      </div>

      <div className="status-line">
        <div>Category</div>
        <div>Select {activeCategory}</div>
      </div>

      <div className="filter-body">
        <div className="filter-categories">
          {categories.map((cat) => (
            <Button
              key={cat.value}
              className={selectedCategory === cat.value ? "active" : ""}
              onClick={() => setSelectedCategory(cat.value)}
              block
            >
              {cat.title}
            </Button>
          ))}
        </div>

        <div className="filter-metrics">
          <div className="select-all">
            <button type="button" onClick={handleSelectAll}>
              Select All
            </button>
          </div>

          <div className="trust-list">
            {visibleList.length > 0 ? (
              visibleList.map((trust) => (
                <div key={trust?.name} className="trust-item">
                  <Checkbox
                    checked={selectedTrustMap[selectedCategory]?.includes(
                      trust?.name
                    )}
                    onChange={() => toggleTrust(trust)}
                  >
                    {trust?.name}
                  </Checkbox>
                </div>
              ))
            ) : (
              <div className="trust-empty">
                <b>No {activeCategory.toLowerCase()} found</b>
                <span>
                  {search
                    ? "Try a different search."
                    : "Nothing to drill into for this category."}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}
    </Modal>
  );
};

export default ChartFilterModal;
